import { useEffect, useRef } from "react";

const recWidth = 208
const extWidth = 12

const directionNameList = [
    "北",
    "北东北",
    "东北",
    "东东北",
    "东",
    "东东南",
    "东南",
    "南东南",
    "南",
    "南西南",
    "西南",
    "西西南",
    "西",
    "西西北",
    "西北",
    "北西北",
]

export const getDirectionName = (degrees: number) => {
    let index = 0;
    if (348.75 <= degrees && degrees <= 360) {
        index = 0;
    } else if (0 <= degrees && degrees <= 11.25) {
        index = 0;
    } else if (11.25 < degrees && degrees <= 33.75) {
        index = 1;
    } else if (33.75 < degrees && degrees <= 56.25) {
        index = 2;
    } else if (56.25 < degrees && degrees <= 78.75) {
        index = 3;
    } else if (78.75 < degrees && degrees <= 101.25) {
        index = 4;
    } else if (101.25 < degrees && degrees <= 123.75) {
        index = 5;
    } else if (123.75 < degrees && degrees <= 146.25) {
        index = 6;
    } else if (146.25 < degrees && degrees <= 168.75) {
        index = 7;
    } else if (168.75 < degrees && degrees <= 191.25) {
        index = 8;
    } else if (191.25 < degrees && degrees <= 213.75) {
        index = 9;
    } else if (213.75 < degrees && degrees <= 236.25) {
        index = 10;
    } else if (236.25 < degrees && degrees <= 258.75) {
        index = 11;
    } else if (258.75 < degrees && degrees <= 281.25) {
        index = 12;
    } else if (281.25 < degrees && degrees <= 303.75) {
        index = 13;
    } else if (303.75 < degrees && degrees <= 326.25) {
        index = 14;
    } else if (326.25 < degrees && degrees < 348.75) {
        index = 15;
    }
    let name = directionNameList[index]
    return name
}

export function CompassCanvas(props: { angle: number }) {

    const canvasRef = useRef(null);

    useEffect(() => {
        if (!props.angle && props?.angle != 0) return
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            draw(ctx);
        }
    }, [props.angle]);

    const draw = (ctx: CanvasRenderingContext2D) => {
        ctx.canvas.width = recWidth + extWidth;
        ctx.canvas.height = recWidth + extWidth;
        const centerX = (recWidth + extWidth) / 2;
        const centerY = (recWidth + extWidth) / 2;
        const radius = recWidth / 2;
        const totalMarks = 52;
        const majorMarkInterval = 13;
        const maskLength = 21

        // 循环绘制外层圆环
        for (let i = 0; i < totalMarks; i++) {
            const angle = (i / totalMarks) * 2 * Math.PI;
            const xStart = centerX + (radius - maskLength) * Math.cos(angle);
            const yStart = centerY - (radius - maskLength) * Math.sin(angle);

            let xEnd, yEnd;
            if (i % majorMarkInterval === 0) {
                // 重要刻度
                xEnd = centerX + radius * Math.cos(angle);
                yEnd = centerY - radius * Math.sin(angle);
                ctx.strokeStyle = '#fff';
                ctx.lineWidth = 2;
            } else {
                // 非重要刻度
                xEnd = centerX + radius * Math.cos(angle);
                yEnd = centerY - radius * Math.sin(angle);
                ctx.strokeStyle = 'rgba(255,255,255,0.5)';
                ctx.lineWidth = 1;
            }

            ctx.beginPath();
            ctx.moveTo(xStart, yStart);
            ctx.lineTo(xEnd, yEnd);
            ctx.stroke();
        }

        // 绘制中央小圆盘
        const circleRadius = 53
        ctx.beginPath();
        ctx.arc(centerX, centerY, circleRadius, 0, 2 * Math.PI);
        ctx.fillStyle = '#6F9BE7';
        ctx.filter = 'drop-shadow(0px 4px 24px rgba(37, 43, 58, 0.24))';
        ctx.fill();

        // 清空样式
        ctx.filter = 'none';
        // 绘制指针条
        // 将指北顺时针的角度变为和x轴的逆时针角度
        let angle_360 = (props.angle * 180 / Math.PI) % 360
        let supple_angle = 360 - angle_360
        let newAngle = supple_angle + 90
        drawPointer(ctx, centerX, centerY, radius, circleRadius, newAngle);
        // 绘制文字
        drawFont(ctx, centerX, centerY, radius, angle_360)
    }

    const drawFont = (ctx: CanvasRenderingContext2D, centerX: number, centerY: number, radius: number, angle: number) => {
        let centerName = getDirectionName(angle)
        // 绘制中心文字
        ctx.font = 'normal 20px Arial'
        ctx.fillStyle = '#fff'
        ctx.fillText(centerName, centerX - 10 * centerName.length, centerY + 8)
        // 绘制北
        ctx.font = 'normal 20px Arial'
        ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
        ctx.fillText("北", centerX - 10, centerY - radius + 45)
        // 绘制东
        ctx.font = 'normal 20px Arial'
        ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
        ctx.fillText("东", centerX + radius - 45, centerY + 6)
        // 绘制南
        ctx.font = 'normal 20px Arial'
        ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
        ctx.fillText("南", centerX - 10, centerY + radius - 30)
        // 绘制西
        ctx.font = 'normal 20px Arial'
        ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
        ctx.fillText("西", centerX - radius + 25, centerY + 6)
    }

    const drawPointer = (ctx: CanvasRenderingContext2D, centerX: number, centerY: number, radius: number, innerRadius: number, angle: number) => {
        const radianAngle = (angle * Math.PI) / 180;

        // 指针前段起止位置
        const lineStart_startX = centerX + innerRadius * Math.cos(radianAngle);
        const lineStart_startY = centerY - innerRadius * Math.sin(radianAngle);
        const lineStart_endX = centerX + (radius - 2) * Math.cos(radianAngle);
        const lineStart_endY = centerY - (radius - 2) * Math.sin(radianAngle);

        // 绘制前段指针线段
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 4;
        ctx.beginPath();
        ctx.moveTo(lineStart_startX, lineStart_startY);
        ctx.lineTo(lineStart_endX, lineStart_endY);
        ctx.stroke();

        // 指针后端起止位置
        const lineEnd_startX = centerX + innerRadius * Math.cos(radianAngle + Math.PI);
        const lineEnd_startY = centerY - innerRadius * Math.sin(radianAngle + Math.PI);
        const lineEnd_endX = centerX + (radius - 12) * Math.cos(radianAngle + Math.PI);
        const lineEnd_endY = centerY - (radius - 12) * Math.sin(radianAngle + Math.PI);
        // 绘制后段指针线段
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 4;
        ctx.beginPath();
        ctx.moveTo(lineEnd_startX, lineEnd_startY);
        ctx.lineTo(lineEnd_endX, lineEnd_endY);
        ctx.stroke();

        // 绘制箭头
        const arrow_endX = centerX + (radius + 6) * Math.cos(radianAngle);
        const arrow_endY = centerY - (radius + 6) * Math.sin(radianAngle);
        drawArrowhead(ctx, arrow_endX, arrow_endY, radianAngle);
        // 绘制底部圆环
        const endRing_x = centerX + (radius - 4) * Math.cos(radianAngle + Math.PI);
        const endRing_y = centerY - (radius - 4) * Math.sin(radianAngle + Math.PI);
        drawRing(ctx, endRing_x, endRing_y, 8.5, 4)
    };

    const drawArrowhead = (ctx: CanvasRenderingContext2D, x: number, y: number, angle: number) => {
        const arrowLength = 12;  // 箭头的长度
        const arrowWidth = 6;    // 箭头的宽度

        ctx.fillStyle = '#fff';
        ctx.beginPath();

        // 画出箭头顶点
        ctx.moveTo(x, y);

        // 画出箭头的左侧
        ctx.lineTo(
            x - arrowLength * Math.cos(angle - Math.atan(arrowWidth / arrowLength)),
            y + arrowLength * Math.sin(angle - Math.atan(arrowWidth / arrowLength))
        );

        // 画出箭头的右侧
        ctx.lineTo(
            x - arrowLength * Math.cos(angle + Math.atan(arrowWidth / arrowLength)),
            y + arrowLength * Math.sin(angle + Math.atan(arrowWidth / arrowLength))
        );

        ctx.closePath();
        ctx.fill();
    };

    const drawRing = (ctx: CanvasRenderingContext2D, centerX: number, centerY: number, radius: number, width: number) => {
        ctx.beginPath()
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, false)
        ctx.lineWidth = width
        ctx.strokeStyle = '#fff'
        ctx.lineWidth = 4
        ctx.stroke()

        // 绘制中央小圆盘
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius - 2, 0, 2 * Math.PI);
        ctx.fillStyle = '#687486';
        ctx.fill();
    };

    return (
        <canvas
            style={{
                height: recWidth + extWidth,
                width: recWidth + extWidth,
                margin: "auto"
            }}
            ref={canvasRef}
        />
    )
}